import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import {
  LayoutDashboard, Inbox, FileText, Wrench, HelpCircle, ClipboardList,
  Newspaper, Bot, Rss, AlarmClock, Settings, ShieldBan, Users,
} from 'lucide-react';

const AdminLayout = () => {
  const { user, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const navLinks = [
    { to: '/admin/dashboard', label: 'Панель управления', icon: LayoutDashboard },
    { to: '/admin/inquiries', label: 'Заявки', icon: Inbox },
    { to: '/admin/pages', label: 'Страницы сайта', icon: FileText },
    { to: '/admin/services', label: 'Услуги и категории', icon: Wrench },
    { to: '/admin/faqs', label: 'FAQ', icon: HelpCircle },
    { to: '/admin/documents', label: 'Документы', icon: ClipboardList },
    { to: '/admin/articles', label: 'Статьи', icon: Newspaper },
    { to: '/admin/news-agent', label: 'AI News Agent', icon: Bot },
    { to: '/admin/news-sources', label: 'Источники новостей', icon: Rss },
    { to: '/admin/cron-monitoring', label: 'Планировщик задач', icon: AlarmClock },
    { to: '/admin/settings', label: 'Настройки', icon: Settings },
    { to: '/admin/blocked-ips', label: 'Блокировка IP', icon: ShieldBan },
    { to: '/admin/users', label: 'Пользователи', icon: Users },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-bold text-gray-900">ВЕЛОКС ХИНТ Admin</h1>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-700">
                {user?.username} ({user?.role})
              </span>
              <button
                onClick={handleLogout}
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition"
              >
                Выйти
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="flex">
        {/* Sidebar */}
        <aside className="w-64 bg-white min-h-screen shadow-sm">
          <nav className="p-4 space-y-2">
            {navLinks.map((link) => {
              const Icon = link.icon;
              return (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) =>
                    `flex items-center space-x-3 px-4 py-3 rounded-lg transition ${
                      isActive
                        ? 'bg-blue-600 text-white'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`
                  }
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span className="font-medium">{link.label}</span>
                </NavLink>
              );
            })}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
